import React from 'react';

const CheckboxInput = ({ id, label, name, checked, onChange, disabled=false }) => {
  return (
    <div className="mb-4">
      <label htmlFor={id} className="group inline-flex cursor-pointer items-center gap-2 rounded-md px-1 py-0.5 transition hover:bg-gray-50">
        <input
          id={id}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="h-4 w-4 rounded border-gray-300 text-primary"
          disabled={disabled}
        />
        <span className="text-sm text-gray-700 transition group-hover:text-gray-900">{label}</span>
      </label>
    </div>
  );
};

export default CheckboxInput;